import { Component, Input } from '@angular/core';
import * as _ from 'lodash';

import { MAX_TEXT_LENGTH } from '../../model/constants';

@Component( {
    selector: 'psv-collapsible-block-view',
    templateUrl: './collapsible-block-view.component.html',
    standalone: false
} )
export class CollapsibleBlockViewComponent {
    @Input() headers: string[] = [];
    @Input() expandToolTip = '';
    @Input() collapseToolTip = '';
    @Input() hisObjects: any[];
    @Input() hisAttribute: string;

    showFullText = false;
    public maxLength = MAX_TEXT_LENGTH;
    
    /* set to show the full/shortened text */
    setShowFullText( showFullText: boolean ): void {
        this.showFullText = showFullText;
    }
    
    /* compares the text.length to the specified maximum */
    public isMaxTextLength(): boolean {
        let text = this.hisObjects[this.firstValidIndex][this.hisAttribute];
        return text && text.length > MAX_TEXT_LENGTH;
    }
    
    get firstValidIndex() {
        for (let index = 0; index < this.hisObjects.length; index++) {
            if(this.isEntryValid(this.hisObjects[index])) {
                return index;
            }
        }
        return -1;
    }
    
    isEntryValid(entry: any): boolean {
        if(!entry) {
            return false;
        }
        const textValue: string = entry[this.hisAttribute];
        return textValue && textValue.length > 0;
    }
    
    get showButtons(): boolean {
        // more than one valid entry?
        let validEntries = 0;
        for (let index = 0; index < this.hisObjects.length; index++) {
            if(this.isEntryValid(this.hisObjects[index])) {
                validEntries++;
            }
        }
        return validEntries > 1 || this.hisObjects[this.firstValidIndex][this.hisAttribute].length >= MAX_TEXT_LENGTH;
    }
}
